module.exports = {
  "ids": {
    "autocomplete": {
      "input": {
        "spacing": {
          "inset-right": {
            "loading": {
              "nob": [
                "system",
                "component",
                "element",
                "category",
                "variant",
                "state"
              ],
              "value": "3rem",
              "filePath": "./src/tokens/autocomplete.json",
              "isSource": true,
              "original": {
                "nob": [
                  "system",
                  "component",
                  "element",
                  "category",
                  "variant",
                  "state"
                ],
                "value": "{ids.size.48.value}"
              },
              "name": "IDS_AUTOCOMPLETE_INPUT_SPACING_INSET_RIGHT_LOADING",
              "attributes": {
                "system": "ids",
                "component": "autocomplete",
                "element": "input",
                "category": "spacing",
                "variant": "inset-right",
                "state": "loading"
              },
              "path": [
                "ids",
                "autocomplete",
                "input",
                "spacing",
                "inset-right",
                "loading"
              ]
            }
          }
        }
      }
    },
    "suggestions": {
      "color": {
        "background": {
          "nob": [
            "system",
            "component",
            "category",
            "property"
          ],
          "value": "rgb(250, 249, 247)",
          "filePath": "./src/tokens/autocomplete.json",
          "isSource": true,
          "original": {
            "nob": [
              "system",
              "component",
              "category",
              "property"
            ],
            "value": "{ids.color.beige.100.value}"
          },
          "name": "IDS_SUGGESTIONS_COLOR_BACKGROUND",
          "attributes": {
            "system": "ids",
            "component": "suggestions",
            "category": "color",
            "property": "background"
          },
          "path": [
            "ids",
            "suggestions",
            "color",
            "background"
          ]
        }
      },
      "list-item": {
        "content": {
          "icon": {
            "media-query": {
              "base": {
                "nob": [
                  "system",
                  "component",
                  "element",
                  "category",
                  "property",
                  "category",
                  "scale"
                ],
                "value": "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' stroke-width='3' viewBox='0 0 32 32'%3E%3Cg fill='none' stroke-miterlimit='10' stroke='%23331e11'%3E%3Cpath data-cap='butt' d='M30 30L2 2'/%3E%3Cpath stroke-linecap='square' d='M14 2H2v12'/%3E%3C/g%3E%3C/svg%3E\")",
                "filePath": "./src/tokens/autocomplete.json",
                "isSource": true,
                "original": {
                  "nob": [
                    "system",
                    "component",
                    "element",
                    "category",
                    "property",
                    "category",
                    "scale"
                  ],
                  "value": "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' stroke-width='3' viewBox='0 0 32 32'%3E%3Cg fill='none' stroke-miterlimit='10' stroke='%23331e11'%3E%3Cpath data-cap='butt' d='M30 30L2 2'/%3E%3Cpath stroke-linecap='square' d='M14 2H2v12'/%3E%3C/g%3E%3C/svg%3E\")"
                },
                "name": "IDS_SUGGESTIONS_LIST_ITEM_CONTENT_ICON_MEDIA_QUERY_BASE",
                "attributes": {
                  "system": "ids",
                  "component": "suggestions",
                  "element": "list-item",
                  "category": [
                    "content",
                    "media-query"
                  ],
                  "property": "icon",
                  "scale": "base"
                },
                "path": [
                  "ids",
                  "suggestions",
                  "list-item",
                  "content",
                  "icon",
                  "media-query",
                  "base"
                ]
              },
              "smlr": {
                "nob": [
                  "system",
                  "component",
                  "element",
                  "category",
                  "property",
                  "category",
                  "scale"
                ],
                "value": "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Cg stroke-width='3' fill='none' stroke='%23331e11' stroke-miterlimit='10'%3E%3Cpath data-cap='butt' data-color='color-2' d='M2 21h20a8 8 0 008-8V3'/%3E%3Cpath stroke-linecap='square' d='M10 13l-8 8 8 8'/%3E%3C/g%3E%3C/svg%3E\")",
                "filePath": "./src/tokens/autocomplete.json",
                "isSource": true,
                "original": {
                  "nob": [
                    "system",
                    "component",
                    "element",
                    "category",
                    "property",
                    "category",
                    "scale"
                  ],
                  "value": "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Cg stroke-width='3' fill='none' stroke='%23331e11' stroke-miterlimit='10'%3E%3Cpath data-cap='butt' data-color='color-2' d='M2 21h20a8 8 0 008-8V3'/%3E%3Cpath stroke-linecap='square' d='M10 13l-8 8 8 8'/%3E%3C/g%3E%3C/svg%3E\")"
                },
                "name": "IDS_SUGGESTIONS_LIST_ITEM_CONTENT_ICON_MEDIA_QUERY_SMLR",
                "attributes": {
                  "system": "ids",
                  "component": "suggestions",
                  "element": "list-item",
                  "category": [
                    "content",
                    "media-query"
                  ],
                  "property": "icon",
                  "scale": "smlr"
                },
                "path": [
                  "ids",
                  "suggestions",
                  "list-item",
                  "content",
                  "icon",
                  "media-query",
                  "smlr"
                ]
              }
            }
          }
        },
        "color": {
          "text": {
            "nob": [
              "system",
              "component",
              "element",
              "category",
              "property"
            ],
            "value": "rgb(51, 30, 17)",
            "filePath": "./src/tokens/autocomplete.json",
            "isSource": true,
            "original": {
              "nob": [
                "system",
                "component",
                "element",
                "category",
                "property"
              ],
              "value": "{ids.color.brown.200.value}"
            },
            "name": "IDS_SUGGESTIONS_LIST_ITEM_COLOR_TEXT",
            "attributes": {
              "system": "ids",
              "component": "suggestions",
              "element": "list-item",
              "category": "color",
              "property": "text"
            },
            "path": [
              "ids",
              "suggestions",
              "list-item",
              "color",
              "text"
            ]
          },
          "background": {
            "normal": {
              "nob": [
                "system",
                "component",
                "element",
                "category",
                "property",
                "state"
              ],
              "value": "rgba(0, 0, 0, 0)",
              "filePath": "./src/tokens/autocomplete.json",
              "isSource": true,
              "original": {
                "nob": [
                  "system",
                  "component",
                  "element",
                  "category",
                  "property",
                  "state"
                ],
                "value": "transparent"
              },
              "name": "IDS_SUGGESTIONS_LIST_ITEM_COLOR_BACKGROUND_NORMAL",
              "attributes": {
                "system": "ids",
                "component": "suggestions",
                "element": "list-item",
                "category": "color",
                "property": "background",
                "state": "normal"
              },
              "path": [
                "ids",
                "suggestions",
                "list-item",
                "color",
                "background",
                "normal"
              ]
            },
            "hover": {
              "nob": [
                "system",
                "component",
                "element",
                "category",
                "property",
                "state"
              ],
              "value": "rgb(241, 236, 232)",
              "filePath": "./src/tokens/autocomplete.json",
              "isSource": true,
              "original": {
                "nob": [
                  "system",
                  "component",
                  "element",
                  "category",
                  "property",
                  "state"
                ],
                "value": "{ids.color.beige.300.value}"
              },
              "name": "IDS_SUGGESTIONS_LIST_ITEM_COLOR_BACKGROUND_HOVER",
              "attributes": {
                "system": "ids",
                "component": "suggestions",
                "element": "list-item",
                "category": "color",
                "property": "background",
                "state": "hover"
              },
              "path": [
                "ids",
                "suggestions",
                "list-item",
                "color",
                "background",
                "hover"
              ]
            }
          }
        },
        "size": {
          "height": {
            "nob": [
              "system",
              "component",
              "element",
              "category",
              "property"
            ],
            "value": "2.5rem",
            "filePath": "./src/tokens/autocomplete.json",
            "isSource": true,
            "original": {
              "nob": [
                "system",
                "component",
                "element",
                "category",
                "property"
              ],
              "value": "{ids.size.40.value}"
            },
            "name": "IDS_SUGGESTIONS_LIST_ITEM_SIZE_HEIGHT",
            "attributes": {
              "system": "ids",
              "component": "suggestions",
              "element": "list-item",
              "category": "size",
              "property": "height"
            },
            "path": [
              "ids",
              "suggestions",
              "list-item",
              "size",
              "height"
            ]
          }
        },
        "spacing": {
          "inset": {
            "nob": [
              "system",
              "component",
              "element",
              "category",
              "variant"
            ],
            "value": "0.75rem 1rem",
            "filePath": "./src/tokens/autocomplete.json",
            "isSource": true,
            "original": {
              "nob": [
                "system",
                "component",
                "element",
                "category",
                "variant"
              ],
              "value": "{ids.size.spacing.smallest.value} {ids.size.spacing.smaller.value}"
            },
            "name": "IDS_SUGGESTIONS_LIST_ITEM_SPACING_INSET",
            "attributes": {
              "system": "ids",
              "component": "suggestions",
              "element": "list-item",
              "category": "spacing",
              "variant": "inset"
            },
            "path": [
              "ids",
              "suggestions",
              "list-item",
              "spacing",
              "inset"
            ]
          }
        }
      }
    },
    "autocomplete-tags": {
      "tag": {
        "spacing": {
          "stack": {
            "nob": [
              "system",
              "component",
              "element",
              "category",
              "variant"
            ],
            "value": "7px",
            "filePath": "./src/tokens/tags.json",
            "isSource": true,
            "original": {
              "nob": [
                "system",
                "component",
                "element",
                "category",
                "variant"
              ],
              "value": "7px"
            },
            "name": "IDS_AUTOCOMPLETE_TAGS_TAG_SPACING_STACK",
            "attributes": {
              "system": "ids",
              "component": "autocomplete-tags",
              "element": "tag",
              "category": "spacing",
              "variant": "stack"
            },
            "path": [
              "ids",
              "autocomplete-tags",
              "tag",
              "spacing",
              "stack"
            ]
          }
        }
      },
      "input": {
        "size": {
          "height": {
            "nob": [
              "system",
              "component",
              "element",
              "category",
              "variant"
            ],
            "value": "2rem",
            "filePath": "./src/tokens/tags.json",
            "isSource": true,
            "original": {
              "nob": [
                "system",
                "component",
                "element",
                "category",
                "variant"
              ],
              "value": "{ids.size.32.value}"
            },
            "name": "IDS_AUTOCOMPLETE_TAGS_INPUT_SIZE_HEIGHT",
            "attributes": {
              "system": "ids",
              "component": "autocomplete-tags",
              "element": "input",
              "category": "size",
              "variant": "height"
            },
            "path": [
              "ids",
              "autocomplete-tags",
              "input",
              "size",
              "height"
            ]
          },
          "min-width": {
            "nob": [
              "system",
              "component",
              "element",
              "category",
              "variant"
            ],
            "value": "6.5rem",
            "filePath": "./src/tokens/tags.json",
            "isSource": true,
            "original": {
              "nob": [
                "system",
                "component",
                "element",
                "category",
                "variant"
              ],
              "value": "{ids.size.104.value}"
            },
            "name": "IDS_AUTOCOMPLETE_TAGS_INPUT_SIZE_MIN_WIDTH",
            "attributes": {
              "system": "ids",
              "component": "autocomplete-tags",
              "element": "input",
              "category": "size",
              "variant": "min-width"
            },
            "path": [
              "ids",
              "autocomplete-tags",
              "input",
              "size",
              "min-width"
            ]
          }
        }
      },
      "input-holder": {
        "content": {
          "icon": {
            "loading": {
              "nob": [
                "system",
                "component",
                "element",
                "category",
                "property"
              ],
              "value": "url('https://static.design.if.eu/images/documentation/loader/horizontal.svg')",
              "filePath": "./src/tokens/tags.json",
              "isSource": true,
              "original": {
                "nob": [
                  "system",
                  "component",
                  "element",
                  "category",
                  "property"
                ],
                "value": "url('https://static.design.if.eu/images/documentation/loader/horizontal.svg')"
              },
              "name": "IDS_AUTOCOMPLETE_TAGS_INPUT_HOLDER_CONTENT_ICON_LOADING",
              "attributes": {
                "system": "ids",
                "component": "autocomplete-tags",
                "element": "input-holder",
                "category": "content",
                "property": "icon"
              },
              "path": [
                "ids",
                "autocomplete-tags",
                "input-holder",
                "content",
                "icon",
                "loading"
              ]
            }
          }
        },
        "color": {
          "background": {
            "nob": [
              "system",
              "component",
              "element",
              "category",
              "property"
            ],
            "value": "rgb(250, 249, 247)",
            "filePath": "./src/tokens/tags.json",
            "isSource": true,
            "original": {
              "nob": [
                "system",
                "component",
                "element",
                "category",
                "property"
              ],
              "value": "{ids.color.background.100.value}"
            },
            "name": "IDS_AUTOCOMPLETE_TAGS_INPUT_HOLDER_COLOR_BACKGROUND",
            "attributes": {
              "system": "ids",
              "component": "autocomplete-tags",
              "element": "input-holder",
              "category": "color",
              "property": "background"
            },
            "path": [
              "ids",
              "autocomplete-tags",
              "input-holder",
              "color",
              "background"
            ]
          },
          "text": {
            "nob": [
              "system",
              "component",
              "element",
              "category",
              "property"
            ],
            "value": "rgb(51, 30, 17)",
            "filePath": "./src/tokens/tags.json",
            "isSource": true,
            "original": {
              "nob": [
                "system",
                "component",
                "element",
                "category",
                "property"
              ],
              "value": "{ids.color.brown.200.value}"
            },
            "name": "IDS_AUTOCOMPLETE_TAGS_INPUT_HOLDER_COLOR_TEXT",
            "attributes": {
              "system": "ids",
              "component": "autocomplete-tags",
              "element": "input-holder",
              "category": "color",
              "property": "text"
            },
            "path": [
              "ids",
              "autocomplete-tags",
              "input-holder",
              "color",
              "text"
            ]
          },
          "border": {
            "nob": [
              "system",
              "component",
              "element",
              "category",
              "property"
            ],
            "value": "rgb(51, 30, 17)",
            "filePath": "./src/tokens/tags.json",
            "isSource": true,
            "original": {
              "nob": [
                "system",
                "component",
                "element",
                "category",
                "property"
              ],
              "value": "{ids.color.brown.200.value}"
            },
            "name": "IDS_AUTOCOMPLETE_TAGS_INPUT_HOLDER_COLOR_BORDER",
            "attributes": {
              "system": "ids",
              "component": "autocomplete-tags",
              "element": "input-holder",
              "category": "color",
              "property": "border"
            },
            "path": [
              "ids",
              "autocomplete-tags",
              "input-holder",
              "color",
              "border"
            ]
          }
        },
        "spacing": {
          "inset": {
            "nob": [
              "system",
              "component",
              "element",
              "category",
              "variant"
            ],
            "value": "7px 0.75rem 0",
            "filePath": "./src/tokens/tags.json",
            "isSource": true,
            "original": {
              "nob": [
                "system",
                "component",
                "element",
                "category",
                "variant"
              ],
              "value": "7px {ids.size.spacing.smallest.value} 0"
            },
            "name": "IDS_AUTOCOMPLETE_TAGS_INPUT_HOLDER_SPACING_INSET",
            "attributes": {
              "system": "ids",
              "component": "autocomplete-tags",
              "element": "input-holder",
              "category": "spacing",
              "variant": "inset"
            },
            "path": [
              "ids",
              "autocomplete-tags",
              "input-holder",
              "spacing",
              "inset"
            ]
          }
        },
        "size": {
          "min-height": {
            "nob": [
              "system",
              "component",
              "element",
              "category",
              "property"
            ],
            "value": "3rem",
            "filePath": "./src/tokens/tags.json",
            "isSource": true,
            "original": {
              "nob": [
                "system",
                "component",
                "element",
                "category",
                "property"
              ],
              "value": "{ids.size.48.value}"
            },
            "name": "IDS_AUTOCOMPLETE_TAGS_INPUT_HOLDER_SIZE_MIN_HEIGHT",
            "attributes": {
              "system": "ids",
              "component": "autocomplete-tags",
              "element": "input-holder",
              "category": "size",
              "property": "min-height"
            },
            "path": [
              "ids",
              "autocomplete-tags",
              "input-holder",
              "size",
              "min-height"
            ]
          }
        }
      }
    }
  }
};
